import CaseValuePreview from './CaseValuePreview';
import CaseValueView from './CaseValueView';
import CaseValueEdit from './CaseValueEdit';

const caseValue = {
	preview: CaseValuePreview,
	view: CaseValueView,
	edit: CaseValueEdit,
};
export default caseValue;
